// Persist added state if element is reloaded
const added = new Set();
const cache = new Map();

class QuickAddToCart extends HTMLElement {
    connectedCallback() {
        if (this.hasAttribute('placeholder')) return;

        const observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) {
                 observer.disconnect();
                 this.load(); 
            }
         }, { rootMargin: '0px 0px 50% 0px' });
 
         observer.observe(this);
    }

    async load() {
        if (!this.dataset.handle) return;
        // Fix for SearchSpring - wait for a bit if attribute hasn't been evaluated yet
        if (this.dataset.handle.includes("result.handle")) {
            await new Promise(r => setTimeout(r, 500));
            if (!this.isConnected) return; // Exit if SearchSpring template evaluation removed QATC
        }

        if (theme.freeGift.products.includes(this.dataset.handle)) return;

        this.isButton = this.getAttribute('is-button') != null;
        this.dropdown = this.getAttribute('dropdown') == 'true';

        if (cache.has(this.dataset.handle)) this.content = cache.get(this.dataset.handle);
        else {
            let resp = await fetch(`/products/${this.dataset.handle}?view=quick-add-to-cart`);
            if (!resp.ok) return;
    
            const data = await resp.text();
            cache.set(this.dataset.handle, data)
            this.content = data;
        }

        this.classList.add('data-loaded');

        const parent = this.closest('.product-card, .card, .product-tile');

        if (this.isButton || this.dropdown || !parent || this.getAttribute('init') == 'true') this.init();
        else {
            parent.addEventListener('mouseenter', async () => {
                if (!this.classList.contains('init')) {
                    this.init();
                }
            }); 
    
            if (parent.matches(':hover')) {
                if (!this.classList.contains('init')) {
                    this.init();
                }
            }
        }
    }

    init() {
        this.innerHTML = this.content;

        const registerInterestScript = this.querySelector('#register-interest-script');
        if (registerInterestScript) {
            const newScript = document.createElement('script');
            newScript.src = registerInterestScript.src;
            newScript.type = 'module';
            this.appendChild(newScript);
        }

        if (!this.querySelector('.qatc__button, .qatc__register-interest')) {
            console.error('Quick add to cart content missing, removing');
            this.remove();
        }

        this.classList.add('init');
        
        let content = this.querySelector('.qatc__content');
        if (content) {
            this.addEventListener('mousedown', e => e.stopPropagation());
            this.addEventListener('click', e => {
                e.stopPropagation();
                this.classList.add('active')
            });

            let bundleCard = this.querySelector('.qatc__bundle-card');
            if (bundleCard && !this.dropdown) {
                this.defaultPanel = 'bundle-card'
                this.querySelector('.qatc__bundle-atc').addEventListener('click', e => this.setPanel('buttons'));
            }
            else this.defaultPanel = 'buttons';

            this.setPanel(this.defaultPanel);

            if (this.isButton) {
                this.querySelector('.qatc__label').addEventListener('click', e => {
                    this.transitionIn();
                    this.recalculateHeight();
                });
    
                this.querySelector('.qatc__close-bg').addEventListener('click', e => {
                    e.stopPropagation();
                    this.transitionOut();
                });
                
                this.registerDragLogic();
            }
            else if (this.dropdown) {
                const eventOptions = { capture: true };

                const closeOnClickOut = e => {
                    if (this.classList.contains('show-content') && !this.contains(e.target)) {
                        this.transitionOut();
                        window.removeEventListener('click', closeOnClickOut, eventOptions);
                    }
                };

                this.querySelector('.qatc__label').addEventListener('click', e => {
                    if (!this.classList.contains('show-content')) {
                        this.transitionIn();
                        this.recalculateHeight();

                        window.addEventListener('click', closeOnClickOut, eventOptions);
                    } 
                    else {
                        this.transitionOut();

                        window.removeEventListener('click', closeOnClickOut, eventOptions);
                    }
                });
            }
            else {
                this.querySelector('.qatc__wrapper').addEventListener('mouseenter', e => this.transitionIn());
                this.querySelector('.qatc__wrapper').addEventListener('mouseleave', e => {
                    if (!this.classList.contains('loading') && !this.classList.contains('transition-in') && !this.classList.contains('active') && !this.classList.contains('size-guide-open')) this.transitionOut();
                });
                this.closest('.card, .product-card, .product-tile, .c-recommendedProduct').addEventListener('mouseleave', e => {
                    if (!this.classList.contains('loading') && !this.classList.contains('size-guide-open')) this.transitionOut();
                });
            }   
        }
        this.initButtons();
        this.addEventListener('modalopen', e => this.classList.add('size-guide-open'));
        this.addEventListener('modalclose', e => this.classList.remove('size-guide-open'));

        if (this.dropdown) {
            this.querySelector('.qatc__atc').innerHTML = 'Add';
            this.querySelector('.qatc__atc-label').innerHTML = 'Added';
        }

        let preorderButton = this.querySelector('.preorder-popup__atc');
        if (preorderButton) {
            preorderButton.addEventListener('click', async e => {
                e.preventDefault();

                this.classList.add('loading');
                preorderButton.classList.add('show-loading');

                //added.add(this.dataset.handle);

                await addToCartGlobal(this.dataset.handle, preorderButton.dataset.variant, 1, preorderButton.dataset.isBundle === "true", preorderButton.dataset.preorderMonth);
                window.updateCartDrawer();
                this.fireAtcEvent();

                preorderButton.classList.remove('show-loading');
                this.classList.remove('loading');
                this.transitionOut();
                this.classList.add('added');
            
                setTimeout(() => {
                    this.classList.remove('added')
                }, 2000);
            });

            let back = this.querySelector('.preorder-popup__back');
            if (back) back.addEventListener('click', () => this.setPanel('buttons'));
        }

        this.addEventListener('bissuccess', () => this.recalculateHeight());

        if (added.has(this.dataset.handle)) {
            this.classList.add('added');
            added.delete(this.dataset.handle);
        
            setTimeout(() => {
                this.classList.remove('added')
            }, 2000);
        }
    }

    initButtons() {
        for (let button of this.querySelectorAll('.qatc__button:not(.qatc__button--preorder):not(.preorder-popup__atc)')) {
            button.addEventListener('click', async e => {
                e.preventDefault();

                this.classList.add('loading');
                button.classList.add('show-loading');
                //added.add(this.dataset.handle);

              let props = {};
              try {
                const tontineVariant = window.TontineApp.variantPrices[button.dataset.variant];
                if (tontineVariant) {
                  const variation = window.TontineApp.app.variation.get(tontineVariant.trafficSplit, tontineVariant.multiarmed == 'true');
                  props['_tontinePriceVariant'] = variation;
        		  props['_tontineBValue'] = tontineVariant.number;
                }
              } catch (err) {
                console.log('failed to find tontine variant');
              }

                if (button.dataset.priceTest == 'true' && window.getActivePriceTest()) {
                    props['_PriceTest'] = window.getActivePriceTest();
                }
              
                let error = await addToCartGlobal(this.dataset.handle, button.dataset.variant, 1, button.dataset.isBundle === "true", undefined, props);
    
                button.classList.remove('show-loading');
                this.classList.remove('loading');
                this.transitionOut();

                if (error) {
                    this.querySelector('.qatc__error').innerHTML = error;
                    this.classList.add('error');
                    setTimeout(() => this.classList.remove('error'), 5000);
                }
                else {
                    this.fireAtcEvent();
                    await window.updateCartDrawer();
			        window.showCartDrawer((window.featureEnabled && window.featureEnabled('show-cart')) || Shopify.theme.name.includes('GWP') || window.innerWidth > 992);
                    this.classList.add('added');
                    setTimeout(() => this.classList.remove('added'), 2000);
                }
            });
        }     

        for (let button of this.querySelectorAll('.qatc__button.qatc__button--preorder')) {
            button.addEventListener('click', e => {
                e.preventDefault();
                this.querySelector('.preorder-popup__title').innerHTML = button.dataset.size;
                this.querySelector('.preorder-popup__atc').dataset.variant = button.dataset.variant;
                this.querySelector('.preorder-popup__atc').dataset.isBundle = button.dataset.isBundle;
                this.querySelector('.preorder-popup__atc').dataset.preorderMonth = button.dataset.preorderMonth;

                let bisForm = this.querySelector('bis-form');
                if (bisForm) bisForm.setAttribute('variant', button.dataset.variant);

                this.querySelector('.preorder-popup__month').innerHTML = button.dataset.preorderMonth;
                this.setPanel('preorder');
            });
        }
    }

    setPanel(panel) {
        this.dataset.panel = panel;
        this.recalculateHeight();
    }

    recalculateHeight() {
        let contentHeight = 0;
        this.getBoundingClientRect();

        switch (this.dataset.panel) {
            case 'buttons':
                contentHeight = this.querySelector('.qatc__select-option').clientHeight;
                break;
            case 'bundle-card':
                contentHeight = this.querySelector('.qatc__bundle-card').clientHeight;
                break;
            case 'preorder':
                contentHeight = this.querySelector('.preorder-popup').clientHeight;
                break;
        }

        this.style.setProperty('--content-height', `${contentHeight + 1}px`);
        this.dispatchEvent(new CustomEvent('qatcheightchange', { bubbles: true, detail: { height: contentHeight } }));
        const recs = this.closest('.product-recommendations');
        if (recs) recs.style.setProperty("--qatc-height", `${contentHeight}px`);
    }

    transitionIn() {
        this.classList.add('show-content');
        if (this.dropdown) this.querySelector('.qatc__atc').innerHTML = 'Select a size';
        if (this.isButton) document.documentElement.classList.add('qatc-modal-visible');
        this.classList.add('transition-in');
        this.dispatchEvent(new CustomEvent('qatcopen', { bubbles: true }));

        const recs = this.closest('.product-recommendations');
        if (recs) recs.classList.add('qatc-open');

        this.recalculateHeight();
        setTimeout(() => {
            this.classList.remove('transition-in');

            if (recs) {
                const content = this.querySelector('.qatc__content');
                if (content) content.scrollIntoView({ behaviour: 'smooth', block: 'end', inline: 'nearest' });
            }
        }, 250);
    }

    transitionOut() {
        if (this.dropdown) this.querySelector('.qatc__atc').innerHTML = 'Add';
        if (this.isButton) document.documentElement.classList.remove('qatc-modal-visible');
        this.classList.add('transition-out');
        this.dispatchEvent(new CustomEvent('qatcclose', { bubbles: true }));

        const recs = this.closest('.product-recommendations');
        if (recs) recs.classList.remove('qatc-open');

        setTimeout(() => {
            this.classList.remove('show-content');
            this.classList.remove('transition-out');
            this.classList.remove('active');
            this.setPanel(this.defaultPanel);
        }, 250);
    }

    fireAtcEvent() {
        this.dispatchEvent(new CustomEvent('qatcadd', { bubbles: true }));
        console.log("Fire event");

        if (this.matches('.collection-template-section quick-add-to-cart')) {
            window.dataLayer.push({
                event: 'uxTracking',
                funnelLocation: 'Collection Page Quick Add to Cart'
            });
        }
    }

    registerDragLogic() {
		let popup = this.querySelector('.qatc__content');
		let dragging = false;
		let dragStart = 0;
		let offset = 0;

		// Drag to close logic for mobile
		popup.addEventListener('touchstart', e => {
			let touchPos = e.touches[0].clientY - popup.offsetTop;
			if (touchPos >= 0 && touchPos <= 40) {
				dragging = true;
				dragStart = touchPos;
			}
		});

		popup.addEventListener('touchmove', e => {
			if (dragging) {
				popup.style.transition = '';
				let touchPos = e.touches[0].clientY - popup.offsetTop;
				offset = touchPos - dragStart;
				popup.style.setProperty('--offset', `${Math.max(0, offset)}px`);
			}
		});

		popup.addEventListener('touchend', e => {
			if (dragging) {
				dragging = false;

				// Close dialog if user has moved it far down enough
				if (offset / popup.clientHeight > 0.2) {
					popup.classList.add('swipe-out');

					this.transitionOut();

					setTimeout(() => {
						popup.classList.remove('swipe-out');
						popup.style.removeProperty('--offset');
					}, 500);
				}
				// Otherwise, move it back up
				else {
					popup.style.transition = 'transform 250ms';
					popup.style.removeProperty('--offset');
				}

				dragStart = 0;
				offset = 0;
			}
		});
	}
}

if (!customElements.get('quick-add-to-cart')) customElements.define('quick-add-to-cart', QuickAddToCart);